export const NUMBER_OFF_ALL_ORGANIZATIONS = 100;
